/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon16Solid = forwardRef('DevCodeIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.71 2.28a1 1 0 1 0-1.92-.56l-3.5 12a1 1 0 0 0 1.92.56l3.5-12Z" }),
        React.createElement("path", { d: "M4.457 4.043a1 1 0 0 1 0 1.414L2.056 7.86a.2.2 0 0 0 0 .282l2.401 2.402a1 1 0 1 1-1.414 1.414L.64 9.556a2.2 2.2 0 0 1 0-3.112l2.402-2.401a1 1 0 0 1 1.414 0Z" }),
        React.createElement("path", { d: "M11.543 4.043a1 1 0 0 1 1.414 0l2.402 2.401a2.2 2.2 0 0 1 0 3.112l-2.402 2.401a1 1 0 0 1-1.414-1.414l2.401-2.402a.2.2 0 0 0 0-.282l-2.401-2.402a1 1 0 0 1 0-1.414Z" })));
});
